import dynamic from "next/dynamic";
import { useInView } from "react-intersection-observer";
import { Skeleton } from "../shadcn/components/ui/skeleton";

const LazyComponent = ({ importFunc, id, ...props }: any) => {
  const { ref, inView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const Component = dynamic(importFunc, { ssr: false });

  return (
    <div ref={ref} style={inView ? {} : { minHeight: 300 }}>
      {inView ? (
        <Component {...props} />
      ) : (
        <div className="w-full px-8 sm:px-[100px] 2xl:w-[1340px] 2xl:mx-auto 2xl:px-0">
          <div className="w-full h-full flex flex-col space-y-3 mb-8">
            <Skeleton className="h-48 w-full rounded-xl" />
            <div className="space-y-2">
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
              <Skeleton className="h-4 w-full" />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default LazyComponent;
